import { StyledLeftDrawerContainer } from './Styled';

type LeftDrawerWrapperProps = {
  children?: React.ReactNode;
};

export default function LeftDrawerWrapper({
  children,
}: Readonly<LeftDrawerWrapperProps>) {
  return (
    <StyledLeftDrawerContainer data-testid="leftDrawer" as="nav">
      {children}
    </StyledLeftDrawerContainer>
  );
}
